module.exports = __webpack_public_path__ + "img/nri_logo.dfea6aed.png";